import { sharedUS } from "@shared/locales";
import { signIn } from "@unauthenticated/shared/locales/en/US/signIn";
// eslint-disable-next-line @fullscript/cross-reference
import { patientRxAuth } from "@unauthenticated/signupSignin/locales/en/US/patientRxAuth";

import { common } from "./common";

export const US = {
  ...sharedUS,
  common,
  signIn,
  patientRxAuth,
};
